"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFlashOrder = void 0;
const routes_1 = require("../../routes");
const getFlashOrder = (client) => async (flashOrderId) => {
    const url = routes_1.ENDPOINTS.GET_FLASH_ORDER.applyParams(flashOrderId);
    const response = await client.get(url).catch((error) => {
        if (error?.response?.status === 422) {
            return { data: null };
        }
        throw error;
    });
    return response.data;
};
exports.getFlashOrder = getFlashOrder;
